import { generateToken } from '@/adapters/token';
import { IGenerateToken } from '@/interfaces/token';
import { getQueryParam } from '@/utilities/queryUtils';
import { useMutation } from '@tanstack/react-query';
import { isNil } from 'lodash';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Portal: React.FC = () => {
  const navigate = useNavigate();
  const route = getQueryParam('r');
  const server = getQueryParam('s');
  const username = getQueryParam('u');
  const si = getQueryParam('si');

  const mutations = useMutation({
    mutationFn: async (req: IGenerateToken) => await generateToken(req),
    mutationKey: ['generate-token'],
    onSuccess: (data) => {
      if (data.status === 200) {
        if (data?.data?.token) {
          navigate(`/${route}?token=${data?.data?.token}`);
        }
      }
    },
    onError: (error) => {
      console.log('error', error);
    },
  });

  useEffect(() => {
    if (route && server && username && si) {
      const tokenReq: IGenerateToken = {
        role: 'user',
        serverCode: server,
        site: si,
        username: username,
      };
      mutations.mutateAsync(tokenReq);
    }
  }, [route, server, username, si, mutations]);

  if (isNil(route) || isNil(server) || isNil(username) || isNil(si))
    return <h2 className="text-center">Not found</h2>;

  return <h2 className="text-center">Loading....</h2>;
};

export default Portal;
